import React from 'react';
import { useMutation } from '@tanstack/react-query';

import { useTranslation } from 'react-i18next';
import apiResetPassword from '@app/Services/ForgotPassword/resetPassword';
import { parseError } from '@app/QueryClient/parseError';
import openToaster from '@app/Toastr/openToastr';

import { generatedKeys } from '../queryKeysFactory';

export default function useResetPassword(opt?: {
	onSuccess?: () => void;
	onError?: () => void;
}) {
	const [parsedErrors, setParsedErrors] = React.useState<{
		message?: string;
		errors?: Record<string, unknown>;
	}>({});
	const { t } = useTranslation('forgotPassword');

	const mutation = useMutation({
		mutationKey: generatedKeys.resetPassword.base,
		mutationFn: apiResetPassword,
		onSuccess: () => {
			opt?.onSuccess?.();
		},
		onError: async (error) => {
			opt?.onError?.();
			const parsedError = await parseError(error);
			setParsedErrors({
				message: parsedError?.message,
				errors: parsedError || {},
			});
			if (parsedError?.message) {
				openToaster({
					message: t(parsedError?.message),
					variant: 'error',
				});
			}
		},
	});

	const { mutate } = mutation;

	return {
		...mutation,
		doResetPassword: mutate,
		errors: parsedErrors,
	};
}
